import * as React from "react";
import { ProductOffers } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
const StoreOffersContainer = (props) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.page.details.offers.title")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(ProductOffers, { ...props, labels });
};
export {
  StoreOffersContainer as default
};
//# sourceMappingURL=StoreOffersContainer.js.map
